import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../ui-toolkit/orders/interfaces/IParty';
import { IPartyEntity } from '../../ui-toolkit/orders/interfaces/IPartyEntity';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const isAmericanDigital = (order: IOrderDetailsData | null): boolean => {
  if (!order) return false;
  return hasAmericanDigitalUnderwriter(order.parties);
};

export const hasAmericanDigitalUnderwriter = (parties: IParty[]): boolean => {
  const underwriter = parties.find((party: IParty) => party.purpose === ePartyPurpose.underwriter);
  return underwriter ? (underwriter as IPartyEntity).entity_value === 'AmericanDigital' : false;
};
